import { DeleteOutlined, EditOutlined } from "@ant-design/icons"
import { Button, Popconfirm, message } from "antd"
import { useDispatch } from "react-redux"
import { useEffect } from "react";
import { editAssignment, toggleModal } from "../../../features/assignments/assignmentsSlice";
import { useDeleteAssignmentMutation } from "../../../features/assignments/assignmentsApi";

export default function AssignmentRow({ assignment }) {
  const dispatch = useDispatch();
  const { id, title, video_id, video_title, totalMark } = assignment || {}

  const [deleteAssignment, { isLoading, isError, error }] = useDeleteAssignmentMutation()
  const deleteHander = () => {
    deleteAssignment(assignment?.id)
  }

  useEffect(() => {
    if (isError) {
      const msg = typeof error?.data == 'string' ? error?.data : 'Internal server error'
      message.error(msg)
    }
  }, [error, isError])

  const editHandler = () => {
    dispatch(editAssignment(assignment))
    dispatch(toggleModal(true))
  }
  return (
    <tr>
      <td className="table-td">{title}</td>
      <td className="table-td">{video_title}</td>
      <td className="table-td">{totalMark}</td>

      <td className="table-td ">
        <Popconfirm
          title="Delete the assignment"
          description="Are you sure to delete this assignment?"
          okText="Yes"
          cancelText="No"
          onConfirm={deleteHander}
        >
          <Button type="link" danger><DeleteOutlined /></Button>
        </Popconfirm>
        <Button type="link" onClick={editHandler}><EditOutlined /></Button>
      </td>
    </tr>
  )
}